import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { LanguageService } from '../core/services/language.service';

export const acceptLanguageHeaderInterceptor: HttpInterceptorFn = (
  req,
  next,
) => {
  const languageService = inject(LanguageService);
  const acceptLanguage = languageService.currentLanguageDetails().locale;

  const modifiedReq = req.clone({
    setHeaders: {
      'Accept-Language': acceptLanguage,
    },
  });

  return next(modifiedReq);
};
